function notEmpty(value) {
    return null != value;
}
const src_notEmpty = notEmpty;
export default src_notEmpty;
